import $ from 'jquery';
require('slick-carousel');

$(function() {
    $('.image-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.image-carousel-nav',
        prevArrow: '<div class="slick-prev"><div class="arrow-left"></div></div>',
        nextArrow: '<div class="slick-next"><div class="arrow-right"></div></div>'
    });

    $('.image-carousel-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.image-carousel',
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        prevArrow: '<div class="slick-prev"><div class="arrow-left"></div></div>',
        nextArrow: '<div class="slick-next"><div class="arrow-right"></div></div>'   
    });
});